import React from 'react';
import PropTypes from 'prop-types';
import { feedbackFormHOC, useFeedbackHandlers, FeedbackFormContent } from './FeedbackForm';
import SimpleButton from '../common/appActions/appActionsItems/SimpleButton';

const MobileFeedback = (props) => {
    const { content, charactersLeft, handleContentChange, sendFeedback } = useFeedbackHandlers(
        props.appId,
        props.dispatchFeedback
    );
    if (!props.user) {
        return null;
    }

    return (
        <div className={`ast-app-feedback ast-app-feedback--mobile ${props.className}`}>
            <h3 className="sg-txt-title">Submit feedback</h3>
            <div>
                <FeedbackFormContent
                    content={content}
                    handleContentChange={handleContentChange}
                    charactersLeft={charactersLeft}
                />
                <div className="ast-app-feedback__submit-wrapper">
                    <SimpleButton
                        isDisabled={props.isFetching || content.length === 0}
                        action={sendFeedback}
                        label="Submit"
                    />
                </div>
            </div>
        </div>
    );
};

MobileFeedback.propTypes = {
    user: PropTypes.bool.isRequired,
    appId: PropTypes.string.isRequired,
    dispatchFeedback: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    className: PropTypes.string,
};

const MobileFeedbackHOC = feedbackFormHOC(MobileFeedback);

export default MobileFeedbackHOC;
